import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingAndDebtStep from "./pages/LandingAndDebtStep";
import QualifyStep from "./pages/QualifyStep";
import SuccessPage from "./pages/SuccessPage";

// If you want a header/footer on every page, import and use here
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function App() {
  return (
    <Router>
      {<Header/>}
      <Routes>
        <Route path="/" element={<LandingAndDebtStep />} />
        <Route path="/qualify" element={<QualifyStep />} />
        <Route path="/success" element={<SuccessPage />} />
        {/* Add privacy/terms routes here if you create those pages */}
      </Routes>
      {<Footer/>}
    </Router>
  );
}
